import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 1rem;
  width: 100%;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

const ColumnLeft = styled.div`
  padding: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
`

const ColumnRight = styled.div`
  padding: 0;
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    display: none;
  }
`

export default function TwoColumns({ left, right }) {
    return (
        <Wrapper>
            <ColumnLeft>{left}</ColumnLeft>
            <ColumnRight>{right}</ColumnRight>
        </Wrapper>
    )
}
